var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "caseDealStatus" }, [
    _c(
      "ul",
      {
        ref: "stageFatherBox",
        staticClass: "clearfix",
        style: _vm.processConfig.processContent
      },
      _vm._l(_vm.stageList, function(item, index) {
        return _c(
          "li",
          {
            key: index,
            ref: "stageBox",
            refInFor: true,
            style: _vm.processConfig.stageBox,
            attrs: { id: "stageBox" }
          },
          [_vm._v(_vm._s(item.label))]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d1620a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1620a6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXStageBox/index.vue
// module id = 517
// module chunks = 0